var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCorrectOption(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 30C6.7155 30 0 23.2845 0 15C0 6.7155 6.7155 0 15 0C23.2845 0 30 6.7155 30 15C29.991 23.28 23.28 29.991 15 30ZM14.976 27H15C18.1816 26.9968 21.2316 25.7303 23.4796 23.4789C25.7277 21.2275 26.9896 18.1756 26.988 14.994C26.9864 11.8124 25.7214 8.76174 23.4712 6.5126C21.2209 4.26346 18.1696 3.00001 14.988 3.00001C11.8064 3.00001 8.7551 4.26346 6.50484 6.5126C4.25458 8.76174 2.98959 11.8124 2.988 14.994C2.98641 18.1756 4.24834 21.2275 6.49636 23.4789C8.74437 25.7303 11.7944 26.9968 14.976 27ZM12 22.5L6 16.5L8.115 14.385L12 18.255L21.885 8.37L24 10.5L12 22.5Z",
    fill: "#2ED903"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCorrectOption);
export default __webpack_public_path__ + "static/media/correct-option.c0905330.svg";
export { ForwardRef as ReactComponent };